"use client";

import { RetrievedTeamMember } from "@/lib/sanity/responseTypes";
import { useTranslations } from "next-intl";

interface TeamProps {
  team: RetrievedTeamMember[];
  t: ReturnType<typeof useTranslations>;
  locale: string;
}

export default function Team(props: TeamProps) {
  const { team, t, locale } = props;

  return (
    <div id="team" className="flex flex-col w-full pt-20 px-2.5 gap-[30px] text-primary font-[Outfit]">
      <div className="font-bold text-5xl leading-[120%] w-full text-center">
        {t('team_title')}
      </div>
      <div className="py-2.5 px-[30px] flex flex-col items-center justify-center">
        <div className="flex flex-row flex-wrap gap-5 justify-center max-w-[1360px]">
          {team.map((teamMember, index) => {
            return (
              <div key={`team-member-${index}`} className="flex flex-col p-5 gap-2.5 w-[350px] border-1 border-accent box-border rounded-4xl">
                <img src={`${teamMember.imageUrl}?w=${310 * 2}&h=${413 * 2}`} alt={teamMember.name} className={"aspect-3/4 rounded-4xl w-[310px] object-cover"} />
                <div className="font-bold text-[32px] leading-[120%]">
                  {teamMember.name}
                </div>
                <div className="text-xl leading-[120%]">
                  {teamMember.role[locale]}
                </div>
                {teamMember.intro[locale] && teamMember.intro[locale].length > 0 && (<div className="text-xl leading-[120%]">
                  {teamMember.intro[locale]}
                </div>)}
                <div className="text-xl leading-[120%]">
                  <a href={`mailto:${teamMember.email}`}>{teamMember.email}</a>
                </div>
                <div className="text-xl leading-[120%]">
                  <a href={`tel:${teamMember.mainPhone}`}>{teamMember.mainPhone}</a>
                </div>
                <div className="text-xl leading-[120%]">
                  <a href={`tel:${teamMember.directPhone}`}>{teamMember.directPhone}</a>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
}
